import script from "./BotTab.vue?vue&type=script&setup=true&lang=js"
export * from "./BotTab.vue?vue&type=script&setup=true&lang=js"

import "./BotTab.vue?vue&type=style&index=0&id=6dbd19c1&lang=scss"

const __exports__ = script;

export default __exports__